import { Fragment } from "react";
import { Link } from "react-router-dom";
import { Button } from "components/ui/button";
import { SIGNUP_TYPES, signUpPathFor } from "pages/signup/signupTypes";

export default function SignUpPage() {
  return (
    <div className="flex-1 flex flex-col items-center justify-center px-4 py-12">
      <div className="w-full max-w-lg text-center">
        <h1 className="text-3xl font-semibold text-foreground mb-2">
          Welcome investor!
        </h1>
        <p className="text-muted-foreground mb-8">
          Please select your registration type:
        </p>

        <div className="space-y-4 mb-6">
          {SIGNUP_TYPES.map((type, index) => (
            <Fragment key={type.value}>
              {index > 0 && <p className="text-muted-foreground">or</p>}
              <Button asChild size="lg" className="w-full max-w-xs">
                <Link to={signUpPathFor(type.value)} className="flex items-center gap-2">
                  <type.icon className="h-5 w-5" />
                  {type.label}
                </Link>
              </Button>
            </Fragment>
          ))}
        </div>

        <p className="text-sm text-muted-foreground">
          Already have an account?{" "}
          <Link
            to="/sign-in"
            className="text-accent hover:underline font-medium"
          >
            Log in.
          </Link>
        </p>
      </div>

      <div className="border-t w-full max-w-2xl mt-12 pt-12 text-center">
        <h2 className="text-2xl font-semibold text-foreground mb-4">
          Want to start a crowdfunding project
          <br />
          for your business?
        </h2>
        <Button asChild variant="outline" size="lg">
          <Link to="/raise">List Your Company</Link>
        </Button>
      </div>
    </div>
  );
}
